<template>
  <q-page class="flex flex-center">
    <h5>404 Error: Page not Found </h5>
  </q-page>
</template>

<style>
</style>

<script>
</script>
